<div class="custom-toast">
    <img src="../../../../../../assets/images/profile-icon.png" class="image">
    <span>{{ data.message }}</span>
    <button (click)="close()" style="background: white !important;" class="close-button">
        <mat-icon class="close-icon">close</mat-icon>
    </button>
</div>